export default {"src":"/_next/static/media/note_light.67f49ea4.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};